import React, { useEffect, useState } from 'react';

interface GoogleAdsIconProps {
  size?: number;
  className?: string;
  color?: string;
  strokeWidth?: number; // Accept but ignore (for compatibility with lucide-react)
}

export const GoogleAdsIcon: React.FC<GoogleAdsIconProps> = ({ 
  size = 24, 
  className = '',
  color: _color, // Accept but don't use - just for API compatibility
  strokeWidth: _strokeWidth, // Accept but don't use - just for API compatibility
}) => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check theme from data-theme attribute
    const checkTheme = () => {
      const theme = document.documentElement.getAttribute('data-theme');
      setIsDark(theme === 'dark');
    };

    checkTheme();

    // Watch for theme changes
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    return () => observer.disconnect();
  }, []);

  return (
    <img
      src={isDark ? '/google-ads-white.png' : '/google-ads-black.jpg'}
      alt="Google Ads"
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: 'contain',
        objectPosition: 'center',
        height: size * 1.6,
        width: size * 1.6,
      }}
    />
  );
};
